import React, { useCallback, useEffect, useState } from 'react';
import CopyLinkIconButton, { type CopyLinkIconButtonState } from '../../components/common/CopyLinkIconButton/CopyLinkIconButton';
import { WorkoutAssignmentService, type CopyFupLinkResult } from '../../services/WorkoutAssignmentService';
import { buildFupPublicUrl } from '../../utils/studentPublicLinks';

export type FupCopyLinkParams = {
  studentId: number;
  assignmentId: number | null;
  competence: string;
  onLinkCopied?: (result: CopyFupLinkResult) => void;
};

const FupCopyLinkButton: React.FC<FupCopyLinkParams> = ({
  studentId,
  assignmentId,
  competence,
  onLinkCopied,
}) => {
  const [copyState, setCopyState] = useState<CopyLinkIconButtonState>('idle');

  useEffect(() => {
    if (copyState !== 'success') {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setCopyState('idle');
    }, 5000);

    return () => window.clearTimeout(timer);
  }, [copyState]);

  const handleCopy = useCallback(async () => {
    if (copyState === 'loading') {
      return;
    }

    setCopyState('loading');

    try {
      const result = await WorkoutAssignmentService.copyFupLink({
        assignmentId,
        studentId,
        competence,
      });
      const url = buildFupPublicUrl(result.token, result.student_name_slug);
      await navigator.clipboard.writeText(url);
      onLinkCopied?.(result);
      setCopyState('success');
    } catch (error) {
      setCopyState('idle');
      alert(error instanceof Error ? error.message : 'Não foi possível copiar o link de FUP.');
    }
  }, [assignmentId, competence, copyState, onLinkCopied, studentId]);

  return (
    <CopyLinkIconButton
      state={copyState}
      onClick={handleCopy}
      ariaLabel="Copiar link de FUP"
    />
  );
};

export default FupCopyLinkButton;
